import { Component } from '@angular/core'
import { ControlPanelPage } from '../control-panel/control-panel'

import { AddressProvider } from '../../providers/address/address'

import { NavController, LoadingController, IonicPage, NavParams, ToastController } from 'ionic-angular'

import { Address, AddressType } from '../../models/models'


@IonicPage()
@Component({
	selector: 'page-address-edit',
	templateUrl: 'address-edit.html',
})
export class AddressEditPage {
	public title = "Modifica indirizzo";
	public isNameWritable: boolean = false;
	public isPriorityWritable: boolean = false;
	public isTypeWritable: boolean = false;
	public address: Address
	public loading: any

	constructor(
		public addresses: AddressProvider,
		public loadingCtrl: LoadingController,
		public navCtrl: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController
	) {
		this.address = navParams.get('address')

		let title = navParams.get('title')
		if(title) {
			this.title = title
		} else {
			switch(this.address.type) {
				case AddressType.CONTACT:
					this.title = "Modifica contatto"
					this.isNameWritable = true
					break
				case AddressType.LOCATION:
					this.title = "Modifica indirizzo"
					this.isNameWritable = false
					break
			}
		}

		let isPriorityWritable = navParams.get('isPriorityWritable')
		if(isPriorityWritable || isPriorityWritable === false) {
			this.isPriorityWritable = isPriorityWritable
		}

		let isTypeWritable = navParams.get('isTypeWritable')
		if(isTypeWritable || isTypeWritable === false) {
			this.isTypeWritable = isTypeWritable
		}
	}
	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	public save() {
		let self = this
		this.loading = this.loadingCtrl.create({
			content: 'Salvataggio in corso...',
			dismissOnPageChange: false
		})
		this.loading.present()
		this.addresses.update(this.address).subscribe(
			(address: Address) => {
				self.loading.dismiss()
				console.log("Indirizzo salvato: ", address)
				let toast = self.toastCtrl.create({
					message: 'Indirizzo aggiornato',
					position: 'middle',
					duration: 3000
				})
				toast.present()
				self.navCtrl.pop()
			},
			(error: any) => {
				self.loading.dismiss()
				console.error("Errore salvando l'indirizzo:", error)
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/address-edit/address-edit.ts